import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle         } from '../../Components/UI/UI'

import {    newPosts  } from "../../Data/Data";
import { getWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ThingsToDo.css"

class ThingsToDo extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  


  render(){
    // get all posts 
    const  posts = [ ...newPosts ] ;

    // get non video posts and culinary posts
    const nonVidPosts = posts.filter((o , i )=>{
      return  o.isVid === false  || o.ctg === 'culinary' || o.isDouble === true;


    })

    // const thingsToDoPosts = [ ...posts ];

     const thingsToDoPosts = posts.filter((o , i )=>{
      return (o.isDouble == false);


    })


    const postsHtml = thingsToDoPosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;

       

              if (o.isVid === true) {
         
                url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
                component = <VideoSliderItem  
                              key={i}
                              title={o.title}
                              desc={""}
                              img= {o.img}
                              link={url}
                              cssClass={cssClass} />
              }else {
                // url = "/Posts/" + o.id ;
                url  = "/Posts/" + o.ctg  + '/' + o.id;
                component = <PostSliderItem  
                                key={i}
                                title={o.title}
                                desc={""}
                                img= {o.img}
                                link={url}
                                cssClass={cssClass} />
              }

    
        
        

        return component;
        
    });

    return(
      <div className="inner-page align-center page-ExporeTelAvivAndJerusalem page-thingsToDo">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              THINGS TO DO
            </HomeTitle>
            <div className="live-shows-wrapper">
              {postsHtml}
              
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default ThingsToDo


// WEBPACK FOOTER //
// ./src/Pages/ThingsToDo/ThingsToDo.js